import { render, staticRenderFns } from "./HomeGlobales.vue?vue&type=template&id=33bc6000&scoped=true"
import script from "./HomeGlobales.vue?vue&type=script&lang=js"
export * from "./HomeGlobales.vue?vue&type=script&lang=js"
import style0 from "./HomeGlobales.vue?vue&type=style&index=0&id=33bc6000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc6000",
  null
  
)

export default component.exports